import { useLocations, useMe } from "../api/hooks";
import { describeCounts } from "../lib/locations";
import { ErrorNote, PageHeader, Spinner } from "../components/ui";
import { LocationTable } from "../components/LocationTable";
import { HowItWorksGuide } from "../components/HowItWorksGuide";

export function LocationsPage() {
  const me = useMe().data;
  const locations = useLocations();
  if (locations.isPending) return <Spinner label="Loading locations…" />;
  if (locations.isError) return <ErrorNote error={locations.error} />;
  return (
    <>
      <PageHeader title="My locations" subtitle="The switch on each location turns automatic BTB blocks on or off there. You confirm before anything turns on, and turning off leaves blocks already on the calendar in place." meta={describeCounts(locations.data)} />
      {me && <HowItWorksGuide email={me.email} ownerId={me.ownerIds[0] ?? null} mode={me.mode} />}
      <LocationTable locations={locations.data} emptyTitle="No locations" emptyBody="No locations are linked to your account yet. Contact corporate if that is wrong." />
    </>
  );
}
